import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from './icons/NavIcons';

/**
 * Composant Header commun pour les pages
 * @param {string} title - Titre de la page
 * @param {function} onBack - Fonction personnalisée pour le bouton retour (optionnel)
 * @param {string} backPath - Chemin de navigation pour le retour (optionnel)
 */
const PageHeader = ({ title, onBack, backPath }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="fixed bg-white shadow-sm sticky top-0 z-50">
      <div className="flex items-center p-4">
        <button
          onClick={handleBack}
          className="mr-3"
          aria-label="Retour"
        >
          <ArrowLeftIcon className="w-6 h-6 text-h1 stroke-bleu2" />
        </button>
        <h1 className="text-h1">{title}</h1>
      </div>
    </div>
  );
};

export default PageHeader;
